import { render, staticRenderFns } from "./SSelectVariety.vue?vue&type=template&id=387a6389"
import script from "./SSelectVariety.vue?vue&type=script&lang=js"
export * from "./SSelectVariety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports